const SITUATIONS = [
  {
    icon: 'ri-home-heart-line',
    title: 'Семейный отдых на участке',
    desc: 'Хотите обустроить уютный уголок для&nbsp;всей семьи. Просторные качели, где поместятся и&nbsp;взрослые, и&nbsp;дети&nbsp;—&nbsp;идеальное решение для&nbsp;тёплых&nbsp;вечеров.',
  },
  {
    icon: 'ri-parent-line',
    title: 'Детская площадка',
    desc: 'Нужны безопасные качели для&nbsp;детей. Устойчивая конструкция, плавный ход, отсутствие острых углов&nbsp;—&nbsp;родители спокойны, дети&nbsp;счастливы.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Беседка или зона барбекю',
    desc: 'Обустраиваете зону отдыха с&nbsp;беседкой и&nbsp;мангалом. Качели станут центром притяжения&nbsp;—&nbsp;местом, где&nbsp;гости relax после&nbsp;обеда.',
  },
  {
    icon: 'ri-gift-line',
    title: 'Подарок для дачи',
    desc: 'Ищете оригинальный подарок родителям или&nbsp;друзьям на&nbsp;дачу. Качели ручной работы&nbsp;—&nbsp;это эмоции на&nbsp;годы, а&nbsp;не&nbsp;очередная&nbsp;безделушка.',
  },
];

export default function UseCasesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Подойдёт, если вам нужно
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Четыре ситуации, в которых садовые качели делают участок уютнее и&nbsp;комфортнее
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {SITUATIONS.map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}